/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Roles_PrimaryInputs */

const cs_clients_roles_primary = /** @type {(inputs: Clients_Roles_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primární role`)
};

const en_clients_roles_primary = /** @type {(inputs: Clients_Roles_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary role`)
};

/**
* | output |
* | --- |
* | "Primary role" |
*
* @param {Clients_Roles_PrimaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_roles_primary = /** @type {((inputs?: Clients_Roles_PrimaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Roles_PrimaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_roles_primary(inputs)
	return cs_clients_roles_primary(inputs)
});